// extracted by mini-css-extract-plugin
module.exports = {"container":"page_banner-module--container--3MaBq"};